import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import Entry from "@/pages/Entry";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Profile from "@/pages/Profile";
import Properties from "@/pages/Properties";
import MyRequests from "@/pages/MyRequests";
import RequestDetail from "@/pages/RequestDetail";
import Urgency from "@/pages/Urgency";
import QuoteForm from "@/pages/QuoteForm";
import Confirmation from "@/pages/Confirmation";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminJob from "@/pages/AdminJob";
import AdminCustomers from "@/pages/AdminCustomers";
import AdminCalendar from "@/pages/AdminCalendar";

function Protected({ children }) {
  const { customer, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-primary">Loading…</div>;
  if (!customer) return <Navigate to="/login" replace />;
  return children;
}

function EntryGate() {
  const { customer, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-primary">Loading…</div>;
  if (customer) return <Navigate to="/urgency" replace />;
  return <Entry />;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<EntryGate />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/home" element={<Protected><Home /></Protected>} />
            <Route path="/profile" element={<Protected><Profile /></Protected>} />
            <Route path="/properties" element={<Protected><Properties /></Protected>} />
            <Route path="/my-requests" element={<Protected><MyRequests /></Protected>} />
            <Route path="/requests/:id" element={<Protected><RequestDetail /></Protected>} />
            <Route path="/urgency" element={<Protected><Urgency /></Protected>} />
            <Route path="/quote" element={<Protected><QuoteForm /></Protected>} />
            <Route path="/confirmation" element={<Protected><Confirmation /></Protected>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/customers" element={<AdminCustomers />} />
            <Route path="/admin/customers/:id" element={<AdminCustomers />} />
            <Route path="/admin/calendar" element={<AdminCalendar />} />
            <Route path="/admin/jobs/:id" element={<AdminJob />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" richColors />
      </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
